import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button,
  MenuItem,
  Grid,
} from "@material-ui/core";
import React from "react";
import { useForm } from "react-hook-form";
import { ProjectTmp } from "../models/projectsTmp";

const regions = ["eu-west-1", "us-east-1"];
const targets = ["ecs-fargate"];

export default function ProjectInitDialog(props: {
  open: boolean;
  project: ProjectTmp;
  onSubmit: (data: ProjectTmp) => any;
  setProject: (data: ProjectTmp) => any;
  isNameDuplicate?: boolean;
}) {
  const { handleSubmit, errors, register } = useForm();
  const handleNameChange = (e: any) => {
    props.setProject({ ...props.project, name: e.target.value });
  };
  const handleRegionChange = (e: any) => {
    props.setProject({ ...props.project, region: e.target.value });
  };
  const handleEnvNameChange = (e: any) => {
    props.setProject({ ...props.project, env_name: e.target.value });
  };
  const handleTargetChange = (e: any) => {
    props.setProject({ ...props.project, env_target: e.target.value });
  };
  return (
    <Dialog open={props.open}>
      <form
        onSubmit={handleSubmit((data: ProjectTmp) =>
          props.onSubmit({ ...props.project, ...data })
        )}
      >
        <DialogTitle>New Project</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Name"
                name="name"
                defaultValue="my-project"
                value={props.project.name}
                error={props.isNameDuplicate}
                helperText={props.isNameDuplicate ? "Name already exists" : ""}
                inputRef={register}
                onChange={handleNameChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                select
                name="region"
                label="Region"
                defaultValue="eu-west-1"
                value={props.project.region}
                onChange={handleRegionChange}
                inputRef={register}
                fullWidth
              >
                {regions.map((region) => (
                  <MenuItem value={region} key={region}>
                    {region}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Environment name"
                name="env_name"
                defaultValue="production"
                value={props.project.env_name}
                error={errors.env_name !== undefined}
                helperText={errors.env_name?.message}
                inputRef={register}
                onChange={handleEnvNameChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                select
                name="target"
                label="Target"
                defaultValue="ecs-fargate"
                value={props.project.env_target}
                onChange={handleTargetChange}
                inputRef={register}
                fullWidth
              >
                {targets.map((target) => (
                  <MenuItem value={target} key={target}>
                    {target}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button type="submit">Next</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
